import { color } from '@upstox/upstox-ui';

export const closeIcon: CSSFunction = ({ theme }) => ({
  cursor: 'pointer',
  height: '20px',
  width: '20px',
  color: color(theme, 'icon1'),
  marginLeft: 'auto',
});

export const toast: CSSFunction = ({ cssProps, theme }) => {
  const isError = cssProps?.type === 'error';
  return {
    alignItems: 'flex-start',
    padding: '16px',
    borderRadius: '4px',
    backgroundColor: color(theme, theme.colors.background.default4),
    border: `1px solid ${color(theme, 'ui3')}`,
    borderLeft: `4px solid ${
      isError
        ? theme.colors.background.orange
        : theme.colors.background.green
    }`,
  };
};

export const header: CSSFunction = () => ({
  gap: '10px',
  width: '100%',
  fontSize: '14px',
  fontWeight: '700',
});

export const titleText: CSSFunction = ({ theme }) => ({
  fontSize: '14px',
  fontWeight: '700',
  lineHeight: '20px',
  fontFamily: theme.fonts.tvFont,
  color: color(theme, theme.colors.text.heading1),
});

export const body: CSSFunction = ({ theme }) => ({
  fontSize: '12px',
  fontWeight: '400',
  fontFamily: theme.fonts.tvFont,
  marginTop: '8px',
  lineHeight: '20px',
  color: color(theme, theme.colors.text[2]),
});

export const footer: CSSFunction = () => ({
  marginTop: '8px',
  fontSize: '12px',
  width: '100%',
  display: 'flex',
});

export const actionButton: CSSFunction = () => ({
  padding: 0,
  border: 'none',
  borderRadius: 0,
  marginLeft: 'auto',
});
